import React from "react";
import { ArrowUpRight } from "lucide-react";

const IMAGES = [
  "https://images.unsplash.com/photo-1613915617430-8ab0fd7c6baf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxlZGl0b3JpYWwlMjBmYXNoaW9uJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4MTc4MTgzNHww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/30713507/pexels-photo-30713507.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/30713515/pexels-photo-30713515.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const FeaturedCollection = ({ t }) => {
  return (
    <section
      id="collection"
      data-testid="featured-collection-section"
      className="px-6 md:px-12 lg:px-16 py-24 md:py-32 bg-[#110F0E]"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
        <div className="max-w-2xl">
          <p className="overline mb-5">{t.featured.overline}</p>
          <h2 className="font-serif font-light text-[#F3EFE9] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            {t.featured.title}
          </h2>
        </div>
        <p className="max-w-md text-[#9D9287] text-base md:text-lg leading-relaxed font-light">
          {t.featured.sub}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
        {t.featured.items.map((item, idx) => (
          <article
            key={idx}
            data-testid={`featured-item-${idx}`}
            className="group cursor-pointer"
          >
            <div className="editorial-img aspect-[3/4] mb-5">
              <img src={IMAGES[idx]} alt={item.name} loading="lazy" />
            </div>
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="overline mb-2">{item.tag}</p>
                <h3 className="font-serif text-[#F3EFE9] text-2xl md:text-[26px] font-light tracking-tight">
                  {item.name}
                </h3>
              </div>
              <div className="flex flex-col items-end gap-2">
                <p className="font-mono text-sm text-[#F3EFE9]">{item.price}</p>
                <ArrowUpRight
                  size={18}
                  strokeWidth={1.25}
                  className="text-[#9D9287] group-hover:text-[#A67A53] transition-colors duration-500"
                />
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-16 md:mt-20 flex justify-center">
        <button
          data-testid="featured-view-all-btn"
          className="btn-outline"
        >
          {t.featured.view_all}
        </button>
      </div>
    </section>
  );
};
